import { Button, message, Tabs } from "antd";
import { useTranslation } from "react-i18next";
import ContentLayout from "../components/layout/ContentLayout";
import {
  enableMerchant,
  getMenus,
  getMerchant,
} from "../actions/merchant_actions";
import { useSelector } from "react-redux";
import { useState } from "react";
import { useQuery } from "@tanstack/react-query";
import Loading from "../utils/Loading";
import { Link, useNavigate } from "react-router-dom";
import SearchBar from "../components/SearchBar";
import MenuTable from "../components/MenuTable";
import SecretDisplay from "../components/SecretDisplay";
import MenuFormModal from "../components/MenuFormModal";
import MenuItems from "../components/MenuItems";
import MenuRewards from "../components/MenuRewards";
import MenuDiscounts from "../components/MenuDiscounts";
import MerchantOutlets from "../components/merchant/MerchantOutlets";

export default function Merchant() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const accUrn = useSelector((state) => state.account.urn);
  const businessUrn = useSelector((state) => state.account.businessUrn);
  const [enableLoading, setEnableLoading] = useState(false);
  const [isModalVisible, setIsModalVisible] = useState(false);

  const {
    refetch: refetchMerchant,
    isLoading: merchantLoading,
    data: merchantData,
  } = useQuery({
    queryKey: ["merchant", accUrn],
    queryFn: () => getMerchant({ account_urn: accUrn }),
    enabled: !!accUrn,
  });

  const {
    refetch: refetchMenus,
    isLoading: menusLoading,
    data: menusData,
    error,
  } = useQuery({
    queryKey: ["menus", accUrn],
    queryFn: () => getMenus({ account_urn: accUrn }),
    enabled: !!accUrn,
  });

  if (merchantLoading || menusLoading) return <Loading />;

  const handleEnableMerchant = () => {
    setEnableLoading(true);
    enableMerchant({ account_urn: accUrn, business_urn: businessUrn })
      .then(() => {
        refetchMerchant();
        window.location.reload();
      })
      .catch((err) => {
        message.error(err.response.data?.message || t("something_went_wrong"));
      });
    setEnableLoading(false);
  };

  const cards = [
    {
      link: "orders",
      title: t("total_orders"),
      data: 125,
      imgClass: "img-mov",
      imgSrc: "/assets/images/icons/insights/group.png",
    },
    {
      title: t("total_stamps"),
      data: "18,120",
      imgClass: "img-pink",
      imgSrc: "/assets/images/icons/insights/path.png",
    },
    {
      title: t("total_vouchers"),
      data: "40,689",
      imgClass: "img-orange",
      imgSrc: "/assets/images/icons/insights/reward.png",
    },
  ];

  const items = [
    {
      key: "1",
      label: t("menus"),
      children: (
        <>
          <h2>{t("menu")}</h2>
          <div style={{ width: "100%" }} className="row">
            <Button type="primary" onClick={() => setIsModalVisible(true)}>
              {t("create")}
            </Button>
            <MenuFormModal
              visible={isModalVisible}
              setVisible={setIsModalVisible}
              refetchMenus={refetchMenus}
            />
            <Button onClick={() => navigate("add")}>{t("import")}</Button>
            {/* <SearchBar /> */}
          </div>
          <div style={{ width: "100%" }}>
            <MenuTable
              refetchMenus={refetchMenus}
              data={menusData?.menus || []}
            />
          </div>
        </>
      ),
    },
    {
      key: "2",
      label: t("items"),
      children: <MenuItems />,
    },
    {
      key: "3",
      label: t("rewards"),
      children: (
        <MenuRewards
          data={merchantData?.data?.rewards}
          refetchMerchant={refetchMerchant}
        />
      ),
    },
    {
      key: "4",
      label: t("discounts"),
      children: (
        <MenuDiscounts
          data={merchantData?.data?.discounts}
          refetchMerchant={refetchMerchant}
        />
      ),
    },
    {
      key: "5",
      label: t("outlets"),
      children: (
        <MerchantOutlets
          merchantData={merchantData}
          refetchMerchant={refetchMerchant}
        />
      ),
    },
  ];

  return (
    <ContentLayout
      header={
        <>
          {!merchantData || error ? (
            <div className="screen-notification">
              <img src="/assets/images/bg/shop.png" alt="" />
              <h2 className="active">{t("start_online_merchant")}</h2>
              <h5>{t("create_merchant_now")}</h5>
              <Button
                onClick={handleEnableMerchant}
                className="btn primary"
                loading={enableLoading}
              >
                {t("enable_merchant_now")}
              </Button>
            </div>
          ) : (
            <>
              <h1>{t("merchant_dashboard")}</h1>
              <SecretDisplay merchantData={merchantData} />
              <div className="merchant-insights">
                {cards.map((card, index) => (
                  <Link to="orders" key={index}>
                    <div className="insights_summary-card">
                      <div className="insights_summary-card-header">
                        <div>
                          <h5>{card.title}</h5>
                          <h3>{card.data}</h3>
                        </div>
                        <div className={`img-container ${card.imgClass}`}>
                          <img src={card.imgSrc} alt={card.title} />
                        </div>
                      </div>
                      <div>
                        <h6>
                          <img
                            src="/assets/images/icons/insights/arrow.png"
                            alt="trend"
                          />
                          <span
                            className={
                              card.data.percentage_change >= 0
                                ? "active"
                                : "negative"
                            }
                          >
                            {card.data.percentage_change
                              ? ` ${card.data.percentage_change}%`
                              : "N/A"}
                          </span>{" "}
                          {card.data.percentage_change >= 0
                            ? t("up_from_previous_period")
                            : t("down_from_previous_period")}
                        </h6>
                      </div>
                    </div>
                  </Link>
                ))}
              </div>
              <Tabs
                style={{ width: "100%" }}
                defaultActiveKey="1"
                items={items}
              />
            </>
          )}
        </>
      }
    />
  );
}
